import { TableRow } from './table-row';
import { TableTd } from './table-td';

export class TableRows {
    row: TableRow;
    cells: TableTd[];

    constructor(obj: any) {
        this.row = new TableRow();
        this.row.obj = obj;
        this.cells = [];
    }

    public findCellByColumnId(columnId: string): TableTd {
        return this.cells.find(c => c.columnId === columnId);
    }

    add(cell: TableTd): void {
      this.cells.push(cell);
    }

    addList(...cells: TableTd[]): void {
      cells.forEach(cell => {
        this.add(cell);
      });
    }
}
